import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-vertical-align-center",
  templateUrl: "./med-icon-vertical-align-center.component.html",
})
export class MedIconVerticalAlignCenterComponent extends SvgMixinComponent {}
